// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VueCarousel-slide[data-v-652ae19e]{padding:10px}.VueCarousel[data-v-652ae19e]{max-width:100%}.action__buttons[data-v-652ae19e] .v-btn{height:42px!important}.product__description div[data-v-652ae19e]{white-space:pre-wrap}.v-skeleton-loader__heading[data-v-652ae19e]{margin:0 auto}.product-discount-tag[data-v-652ae19e]{position:absolute;top:0;left:0;color:#fff;z-index:1}", ""]);
// Exports
module.exports = exports;
